/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { calculateDiscountItemGroupUnionModifierRequestSchema } from "./calculateDiscountItemGroupUnionModifierRequestSchema.ts";
import { calculateDiscountItemModifierRequestSchema } from "./calculateDiscountItemModifierRequestSchema.ts";

export const calculateDiscountItemRequestSchema = z
	.object({
		id: z.uuid(),
		amount: z.int().min(1),
		size: z.uuid().nullish(),
		comment: z.string().max(120).nullish(),
		modifiers: z.array(calculateDiscountItemModifierRequestSchema).nullish(),
		group_modifiers: z.array(calculateDiscountItemGroupUnionModifierRequestSchema).nullish(),
		front_item_id: z.uuid().optional(),
		marking_code: z.string().min(1).nullish(),
	})
	.describe("Уменьшение стоимости модификаторов позиции на бесплатные единицы.");
